import { render, staticRenderFns } from "./order-index.vue?vue&type=template&id=0d0cd59e&scoped=true&"
import script from "./order-index.vue?vue&type=script&lang=js&"
export * from "./order-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cd59e",
  null
  
)

export default component.exports